<template>
    <nav id="sidebar">
        <ul class="list-unstyled components mb-5">
            <li :class="checkActive('pelaporan-pajak')" style="cursor: pointer;" @click="$router.push('/pelaporan-pajak')">
                <a><span class="fa fa-home mr-3"></span> Beranda</a>
            </li>
            <li style="cursor: pointer;" @click="$router.push('/landing')">
                <a><span class="fa fa-list mr-3"></span>
                    Halaman Utama</a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: "navBarObjek",
    props: ["active"],
    methods: {
        checkActive(menu) {
            console.log(this.active)
            return this.active == menu ? 'active' : '';
        },
    },
}
</script>